export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=21120135&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/events/id/index.vue?vue&type=template&id=21120135&
// module id = 1407
// module chunks = 0